const CoverTitleFontFamily = {
  GOTHAM: 'Gotham Medium',
  KAUFMANN: 'Kaufmann Regular',
};

module.exports = CoverTitleFontFamily;
